import {round} from "lodash"

const NumToPrecisionString = (num, precision) => {
  const str = num.toString()
  const r = str.split('.')[1]
  if (!r) {
    return str + "." + "0".repeat(precision)
  }

  const cnt = precision - r.length
  if (cnt > 0) {
    return str + "0".repeat(cnt)
  }

  return str
}

const format = (dollars, short, precision) => {
  const decimals = precision === undefined ? 1 : precision

  if (dollars >= 1000000000000) {
    const str = round(dollars / 1000000000000, decimals)
    const units = (short ? "T" : " trillion")
    if (precision) {
      return "$" + NumToPrecisionString(str, decimals) + units
    } else {
      return "$" + str + units
    }
  }

  if (dollars >= 1000000000) {
    const str = round(dollars / 1000000000, decimals)
    const units = (short ? "B" : " billion")
    if (precision) {
      return "$" + NumToPrecisionString(str, decimals) + units
    } else {
      return "$" + str + units
    }
  }

  if (dollars >= 1000000) {
    const str = round(dollars / 1000000, decimals)
    const units = (short ? "M" : " million")
    if (precision) {
      return "$" + NumToPrecisionString(str, decimals) + units
    } else {
      return "$" + str + units
    }
  }

  const str = round(dollars / 1000000, decimals)
  if (precision) {
    return "$" + NumToPrecisionString(str, decimals)
  } else {
    return "$" + str
  }
}

export default format